import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import AppUserTimelineBody from "components/AppUserComponents/AppUserDetails/AppUserTimeline/AppUserTimelineBody/AppUserTimelineBody";

const AppUserTimeline = () => {
  useEffect(() => {
    document.title = "App user";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="appuser" />

      <AppUserTimelineBody />
    </main>
  );
};

export default AppUserTimeline;
